var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 55,
    viewBox: "0 0 51 55",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 27.3516L28.4375 54.6328H21.0547L0.3125 27.9844V26.6484L21.0547 0H28.4375L9.03125 27.3516ZM30.7578 27.3516L50.1641 54.6328H42.7812L22.0391 27.9844V26.6484L42.7812 0H50.1641L30.7578 27.3516Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default ForwardRef;